import moment from 'moment'
import 'moment-timezone'
const useStepInfo = ({
  step,
  resumeReview,
  resumeRevisions,
  coach,
  meetingViaCalendly,
  t,
  serviceRequestList,
}) => {
  const addBusinessDays = (date, days) => {
    let result = new Date(date)
    let addedDays = 0
    while (addedDays < days) {
      result.setDate(result.getDate() + 1)
      // Skip weekends (Saturday=6, Sunday=0)
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++
      }
    }
    return result
  }

  function revisionText() {
    if (resumeReview?.revision_declined) {
      return t('steps.askForRevisions.revision_declined')
    } else if (
      resumeReview?.status == 'closed' &&
      resumeRevisions?.length === 1
    ) {
      return t(`steps.finalFeedback.title_closed`, {
        date: new Date(resumeReview?.completed_at).toLocaleDateString(),
      })
    } else if (
      resumeReview?.status === 'revision_returned' ||
      resumeReview?.status == 'closed'
    ) {
      return `Feedback Received ${
        resumeRevisions?.length > 0 &&
        moment(resumeRevisions[resumeRevisions?.length - 1]?.created_at)
          .tz(moment.tz.guess())
          .format('LLL z')
      }`
    } else if (
      (resumeReview?.status === 'revision_requested' ||
        resumeReview?.status == 'revision_meeting_requested') &&
      resumeRevisions[resumeRevisions?.length - 1]?.calendly_event != undefined
    ) {
      return t('steps.scheduleMeeting.meeting_scheduled', {
        coach_name: coach.first_name,
        date: moment(
          resumeRevisions[resumeRevisions?.length - 1].calendly_event
            ?.start_time,
        )
          .tz(moment.tz.guess())
          .format('LLL z'),
      })
    } else if (
      (resumeReview?.status === 'revision_requested' &&
        !resumeRevisions[resumeRevisions?.length - 1]?.meetingViaCalendly) ||
      resumeReview?.status === 'closed'
    ) {
      return t('steps.askForRevisions.revision_submitted', {
        coach_name: coach.first_name,
        date: moment(resumeRevisions[1]?.created_at)
          .tz(moment.tz.guess())
          .format('LLL z'),
      })
    }
  }

  function meetingText() {
    if (resumeRevisions?.length > 0) {
      return t('steps.scheduleMeeting.meeting_complete', {
        coach_name: coach.first_name,
        date: moment(
          serviceRequestList['ServiceRequest::ResumeReview']?.calendly_event
            ?.start_time,
        ).format('L'),
      })
    }
    if (serviceRequestList['ServiceRequest::ResumeReview']?.calendly_event) {
      return t('steps.scheduleMeeting.meeting_scheduled', {
        coach_name: coach.first_name,
        date: moment(
          serviceRequestList['ServiceRequest::ResumeReview']?.calendly_event
            ?.start_time,
        )
          .tz(moment.tz.guess())
          .format('LLL z'),
      })
    } else if (
      resumeReview?.status === 'assigned' ||
      resumeReview?.status === 'cancelled'
    ) {
      return !meetingViaCalendly
        ? t('steps.scheduleMeeting.coach_assigned_no_meeting', {
            coach_name: coach.first_name,
            date: moment(
              serviceRequestList['ServiceRequest::ResumeReview']?.calendly_event
                ?.start_time,
            ).format('L'),
          })
        : t('steps.scheduleMeeting.coach_assigned', {
            coach_name: coach.first_name,
          })
    } else {
      return t('steps.scheduleMeeting.coach_pending', {
        date: moment(
          addBusinessDays(resumeReview?.created_at, meetingViaCalendly ? 2 : 3),
        ).format('L'),
      })
    }
  }

  const stepInfo = {
    chooseReviewType: `You Selected ${meetingViaCalendly ? 'Meeting With a Coach' : 'Platform Review'}`,
    submitResume: `Submitted ${moment(resumeReview?.created_at).format('L')}`,
    scheduleMeeting: meetingText(),
    receiveFeedback:
      !meetingViaCalendly && !resumeRevisions?.length
        ? meetingText()
        : `Feedback Received ${resumeRevisions?.length > 0 && moment(resumeRevisions[0]?.created_at).tz(moment.tz.guess()).format('LLL z')}`,
    askForRevisions: revisionText(),
  }
  return stepInfo[step]
}

export default useStepInfo
